import { render, staticRenderFns } from "./select-format.vue?vue&type=template&id=62d547b1"
import script from "./select-format.vue?vue&type=script&lang=ts"
export * from "./select-format.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports